import React from 'react'


interface Props {
  className?: string
}


const CourseIconSvg: React.FC<Props> = (props) => {
  return (
    <svg viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" className={props.className}><path d="M24.75 6.518C24.75 2.96 21.727.075 18 .075c-3.728 0-6.75 2.885-6.75 6.443 0 3.559 3.022 6.443 6.75 6.443 3.727 0 6.75-2.884 6.75-6.443zm-8.326 9.739c-4.172-2.438-10.928-3.108-14.329-3.292C.953 12.903 0 13.734 0 14.783v14.954c0 .961.815 1.763 1.863 1.815 3.07.154 9.28.717 13.572 2.78.66.318 1.44-.114 1.44-.796v-16.51c0-.313-.163-.6-.451-.77zm17.48-3.292c-3.4.184-10.157.854-14.328 3.292a.901.901 0 00-.45.78v16.497c0 .684.783 1.116 1.444.799 4.291-2.062 10.498-2.625 13.568-2.779C35.184 31.502 36 30.7 36 29.738V14.783c0-1.049-.953-1.88-2.096-1.818z" /></svg>
  )
}


CourseIconSvg.defaultProps = {
  className: 'w-8 h-8 stroke-current text-black'
}


export default CourseIconSvg;